import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetCabFemalesAction, animalBrowserAction} from '../action';

const tableId = 'comprehensiveBreedingFemale';

function* execute(action: GetCabFemalesAction): SagaIterator {
    const {tableDataRequest} = action.payload;
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findCabBreedingFemales,
        successAction: animalBrowserAction.getCabFemalesSuccess,
        tableId,
    }));
}

/**
 * Loads comprehensive breeding-female rows for the current browser view.
 *
 * @returns The saga watcher for `GET_CAB_FEMALES`.
 */
export function* getCabFemalesSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_CAB_FEMALES', execute);
}
